/* Forstwald, cart-extras.js: Zusätze im Warenkorb (Drawer und Seite).
   1. Anmerkung zur Bestellung speichern (leise), 2. Geschenkverpackung als eigene Zeile an- und abwählen, Kartentext als Eigenschaft der Zeile speichern,
   3. vor der Kasse offene Speicherungen abwarten, 4. den Vorschlag "Passt dazu" erst beim ersten Öffnen holen (Section Rendering, HTML mit section_id).
   Markup: snippets/cart-extras.liquid und cart-suggestion.liquid. Läuft nach theme.js und cart.js. */
(() => {
  'use strict';
  const FW = window.Forstwald;
  if (!FW || !FW.cart || FW.extras) return;
  FW.extras = true;
  const d = document;
  const WRAP_LINE = '[data-wrap-line][data-order-wrap]';
  const say = (inDialog, msg) => {
    if (!msg) return;
    if (inDialog) FW.emit('cart:say', { message: msg });
    else FW.announce(msg);
  };
  const scope = (el) => el.closest('[data-cart-content],[data-main-cart]') || d;
  let pending = null;
  let busy = false;

  /* Schlüssel einer Zeile ändert sich, wenn ihre Eigenschaften sich ändern: im sichtbaren Inhalt nachziehen, bis neu gezeichnet wird */
  const rekey = (from, to) => {
    d.querySelectorAll('[data-line-key="' + from + '"]').forEach((el) => (el.dataset.lineKey = to));
    d.querySelectorAll('[data-remove-with~="' + from + '"]').forEach((el) => {
      el.dataset.removeWith = el.dataset.removeWith.split(' ').map((k) => (k === from ? to : k)).join(' ');
    });
  };

  const saveCard = (ta) => {
    const line = scope(ta).querySelector(WRAP_LINE);
    if (!line) return Promise.resolve();
    const text = ta.value.trim();
    const props = { _geschenk: '1' };
    const gift = ta.closest('[data-cart-extras]').querySelector('[data-cart-gift]');
    if (text && gift) props[gift.dataset.wrapProperty] = text;
    const from = line.dataset.lineKey;
    const p = FW.cart
      .quiet('cart/change.js', { line: parseInt(line.dataset.lineIndex, 10), quantity: parseInt(line.dataset.quantity, 10) || 1, properties: props })
      .then((cart) => {
        ta.dataset.saved = text;
        const now = (cart.items || []).find((i) => i.properties && i.properties._geschenk && !i.properties._fuer);
        if (now) rekey(from, now.key);
      })
      .catch(() => {})
      .then(() => {
        if (pending === p) pending = null;
      });
    pending = p;
    return p;
  };

  const toggleGift = (box) => {
    const root = box.closest('[data-cart-extras]');
    const card = root.querySelector('[data-cart-card]');
    const wrap = root.querySelector('[data-gift-card-wrap]');
    if (busy) {
      box.checked = !box.checked;
      return;
    }
    busy = true;
    const inDialog = !!box.closest('dialog');
    const done = () => (busy = false);
    const fail = (err) => {
      box.checked = !box.checked;
      if (wrap) wrap.hidden = !box.checked;
      FW.emit('cart:error', { message: err && err.status === 422 ? root.dataset.msgError : (err && err.userMessage) || root.dataset.msgError });
    };
    if (wrap) wrap.hidden = !box.checked;
    if (box.checked) {
      const props = { _geschenk: '1' };
      const text = card ? card.value.trim() : '';
      if (text) props[box.dataset.wrapProperty] = text;
      FW.cart.add({ id: parseInt(box.dataset.wrapVariant, 10), quantity: 1, properties: props }, { trigger: box, silent: true }).catch(fail).then(done);
    } else {
      const keys = {};
      scope(box).querySelectorAll(WRAP_LINE).forEach((l) => (keys[l.dataset.lineKey] = 0));
      if (!Object.keys(keys).length) return done();
      FW.cart
        .update(keys, {}, { silent: true })
        .then(() => say(inDialog, root.dataset.msgRemoved))
        .catch(fail)
        .then(done);
    }
  };

  d.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement)) return;
    if (t.matches('[data-cart-note]')) FW.cart.setAttributes({ note: t.value }).catch(() => {});
    else if (t.matches('[data-cart-gift]')) toggleGift(t);
    else if (t.matches('[data-cart-card]')) saveCard(t);
  });
  d.addEventListener('input', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement) || !t.matches('[data-cart-card]')) return;
    const n = t.closest('[data-cart-extras]').querySelector('[data-gift-count]');
    if (n) n.textContent = t.value.length + '/' + (t.maxLength > 0 ? t.maxLength : 200);
  });

  /* Zur Kasse: offene Speicherungen (Kartentext, Menge) abwarten, dann erst absenden, damit nichts verloren geht */
  d.addEventListener('click', (e) => {
    const b = e.target instanceof Element && e.target.closest('[data-cart-checkout]');
    if (!b) return;
    const ta = d.querySelector('[data-cart-card]');
    if (ta && ta.value.trim() !== (ta.dataset.saved !== undefined ? ta.dataset.saved : ta.defaultValue.trim())) saveCard(ta);
    const working = d.querySelector('[data-cart-content][aria-busy="true"],[data-main-cart][aria-busy="true"]');
    if (!pending && !working) return;
    e.preventDefault();
    const id = b.getAttribute('form');
    const go = () => {
      const f = d.getElementById(id);
      const s = d.querySelector('[data-cart-checkout][form="' + id + '"]');
      if (!f) return;
      if (f.requestSubmit) return f.requestSubmit(s || undefined);
      const h = d.createElement('input');
      h.type = 'hidden';
      h.name = 'checkout';
      f.appendChild(h);
      f.submit();
    };
    Promise.all([pending, FW.cart.idle()]).then(go, go);
  });

  /* Geöffnete Zusätze bleiben nach dem Neuzeichnen offen */
  const opened = {};
  d.addEventListener('toggle', (e) => e.target.id && e.target.matches('.cart-extras__details') && (opened[e.target.id] = e.target.open), true);
  FW.on('cart:render', () =>
    d.querySelectorAll('.cart-extras__details').forEach((el) => {
      if (opened[el.id]) el.open = true;
    })
  );

  /* Vorschlag "Passt dazu": Der Platzhalter [data-suggestion-lazy] wird erst geholt, wenn der Drawer offen ist (auf der Seite sofort).
     Die Antwort ist die Section cart-drawer im Modus recs. Der Zwischenspeicher gilt nur für denselben Warenkorb (Adresse plus Produkt-IDs). */
  const cache = {};
  const load = (el) => {
    const key = el.dataset.url + '|' + el.dataset.cartIds;
    if (cache[key] !== undefined) return Promise.resolve(cache[key]);
    return fetch(el.dataset.url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((r) => (r.ok ? r.text() : ''))
      .catch(() => '')
      .then((html) => (cache[key] = html));
  };
  const place = (el, html) => {
    if (!el.isConnected) return;
    const card = new DOMParser().parseFromString(html || '', 'text/html').querySelector('[data-suggestion]');
    const tpl = el.querySelector('template[data-suggestion-fallback]');
    const inCart = card && el.dataset.cartIds.indexOf(',' + card.dataset.productId + ',') > -1;
    let node = null;
    if (card && !inCart) node = d.adoptNode(card);
    else if (tpl && tpl.content.firstElementChild) node = tpl.content.firstElementChild.cloneNode(true);
    if (!node) return el.remove();
    el.replaceWith(node);
    FW.emit('cart:suggestion', { productId: node.dataset.productId, rule: node.dataset.rule });
  };
  const lazy = () =>
    d.querySelectorAll('[data-suggestion-lazy]').forEach((el) => {
      const dlg = el.closest('dialog');
      if ((dlg && !dlg.open) || el.dataset.loading) return;
      el.dataset.loading = '1';
      load(el).then((html) => place(el, html));
    });
  FW.on('dialog:open', lazy);
  FW.on('cart:render', lazy);
  lazy();
})();
